import { connect } from "react-redux"
import RiskAlerts from './RiskAlerts'
import {
  clearSpecificQueryAlert,
  searchRiskAlertsRequest,
  getAlertGraphDataRequest,
  createCaseRequest,
} from '../../../redux/actions/admin'

const mapStateToProps = state => ({
  websocket: state.login.websocket,
  riskAlerts: state.admin.riskAlerts,
  alertGraphData: state.admin.alertGraphData,
  riskAlertsMaxPageSize: 10,
})

const mapDispatchToProps = {
  clearSpecificQueryAlert,
  searchRiskAlertsRequest,
  getAlertGraphDataRequest,
  createCaseRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(RiskAlerts)
